import { Box, useStyleConfig } from "@chakra-ui/react";
import bgImage  from "assets/img/bigbgImage.png"
function PanelContainer(props) {
  const { variant, children, ...rest } = props;
  const styles = useStyleConfig("PanelContainer", { variant });
  // Pass the computed styles into the `__css` prop
  return (
    <Box 
      __css={styles} 
      {...rest}
      bgImage={`url(${bgImage})`}
      bgPosition="center"
      bgRepeat="no-repeat"
      bgSize="-moz-initial"
      >
      {children}
    </Box>
  );
}

export default PanelContainer;
